import {required,email} from "vuelidate/lib/validators";  
const authenticate = {
    data() { 
      return {  
        
        authenticateData: { 
          Email: "",
          Password: ""
          }, 
          FormDataType:{
            Email:{FieldName:"Email",Field:"input",FieldTitle:this.$t('authenticate.AddEdit.Email'),FieldType:"text"},
            Password:{FieldName:"Password",Field:"input",FieldTitle:this.$t('authenticate.AddEdit.Password'),FieldType:"password"}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {  
        Email: { required,email},  
        Password: { required }, 
      }
 
  },
}
export default authenticate